import type { AppModule } from "../types";

export const invoicesModule: AppModule = {
  name: "invoices",
  routes: {
    shell: [
      {
        path: "/invoices",
        handle: { title: "Invoices" },
        lazy: () => import("./pages/InvoicesPage").then((m) => ({ Component: m.InvoicesPage })),
      },
      {
        path: "/invoices/settings",
        handle: { title: "Invoices" },
        lazy: () => import("./pages/InvoiceSettingsPage").then((m) => ({ Component: m.InvoiceSettingsPage })),
      },
      {
        path: "/invoices/:invoiceId",
        handle: { title: "Invoices" },
        lazy: () => import("./pages/InvoiceEditorPage").then((m) => ({ Component: m.InvoiceEditorPage })),
      },
    ],
    "shared-report": [
      {
        path: "/shared/invoice-report/:token",
        handle: { title: "Invoice report" },
        lazy: () => import("./pages/SharedInvoiceReportPage").then((m) => ({ Component: m.SharedInvoiceReportPage })),
      },
    ],
  },
  // Admins always see it (shell rule); granted invoice managers need a shell flag (REQUESTS.md).
  sidebar: [
    {
      id: "INVOICES",
      label: "Invoices",
      path: "/invoices",
      icon: "invoices",
      alt: "View Invoices",
      visible: (ctx) => ctx.isAdmin,
    },
  ],
};
